import script from "./blob-handler-dialog.vue?vue&type=script&setup=true&lang=ts"
export * from "./blob-handler-dialog.vue?vue&type=script&setup=true&lang=ts"

const __exports__ = script;

export default __exports__